import { ApiError } from '@api/client'
import { REFORESTATION_URL } from '@app/links'
import { useI18n } from '@i18n/I18nProvider'
import { ExternalLink } from '@ui/ExternalLink'
import { Icon } from '@ui/Icon'
import { Screen } from '@ui/Screen'
import { ErrorState, LoadingState } from '@ui/States'
import { useSearch } from 'wouter'
import { SpeciesDetails } from './SpeciesDetails'
import { regionFromSearch, useSpecies } from './useSpecies'

export { initialRegion, regionName, regionSections } from './SpeciesDetails'

// Ficha de especie (spec `species`): sus fotos en un carrusel; el nombre es el mismo en todas
// partes; qué es, dónde se planta, qué simboliza y sus referencias culturales cambian según la
// comunidad, así que van en una pestaña por comunidad (`?comunidad=` abre por una).
export const SpeciesPage = ({ id }: { id: string }) => {
	const { t } = useI18n()
	const { data: species, error, isPending, refetch } = useSpecies(id)
	const wanted = regionFromSearch(useSearch())

	if (isPending)
		return (
			<Screen>
				<LoadingState shape="detail" />
			</Screen>
		)
	if (error instanceof ApiError && error.isNotFound)
		return (
			<Screen backHref="/formacion">
				<div role="alert" className="flex flex-col items-center gap-4 py-12 text-center">
					<Icon name="leaf" className="size-12 text-earth-600" />
					<p className="text-lg">{t('species.notFound')}</p>
				</div>
			</Screen>
		)
	if (error || !species) return <ErrorState error={error} onRetry={() => refetch()} />

	return (
		<Screen backHref="/formacion">
			<SpeciesDetails species={species} wantedRegion={wanted} />
			<div className="mt-6">
				<ExternalLink href={REFORESTATION_URL}>Reforestación Camino Vera Cruz</ExternalLink>
			</div>
		</Screen>
	)
}
